// extracted by mini-css-extract-plugin
export var header = "_tb-1";
export var maskBottom = "_tb-6";
export var maskMiddle = "_tb-7";
export var maskTop = "_tb-5";
export var root = "_tb-0";
export var scrollDownButton = "_tb-3";
export var scrollDownButtonHidden = "_tb-4";
export var viewport = "_tb-2";